import LogoSpinner from './LogoSpinner';

export default LogoSpinner;
